<template>
  <div class="tn-travel-results">
    <div class="flex-row">
      <div class="flex-row">
        <input type="text" name="s" placeholder="Finden" :value="getFilter.search" @input="updateFilter({search: $event.target.value})" />
        <div id="dr-picker"
             style="position: relative; width: 250px;"
             class="flex-row"
        >
          <div class="input-wrapper">
            <input type="text"
                   ref="date_range_start"
                   id="date_range_start"
                   placeholder="Von"
                   autocomplete="off"
                   class="range-input"
                   :value="getFilter.date_range[0]"
                   @click="selectDateRangeStart"
            >
            <button type="button"
                    class="clear-input"
                    @click="clearDateRangeStart()"
            ><i class="eicon-editor-close"></i></button>
          </div>
          <div class="input-wrapper">
            <input type="text"
                   ref="date_range_end"
                   id="date_range_end"
                   placeholder="Bis"
                   autocomplete="off"
                   class="range-input"
                   :value="getFilter.date_range[1]"
                   @click="selectDateRangeEnd"
            >
            <button type="button"
                    class="clear-input"
                    @click="clearDateRangeEnd()"
            ><i class="eicon-editor-close"></i></button>
          </div>
          <DrPicker ref="drPicker" @update:range="updateDateRange($event)" />
        </div>
        <div style="margin-left: auto;">
          <select @change="updateSort(sortOptions[parseInt($event.target.value)].value)" style="display: none;">
            <option
                v-for="(option, offset) in sortOptions"
                :key="offset"
                :value="offset"
                :selected="option === selectedSortOption"
                v-html="option.label"
            ></option>
          </select>
          <div class="view-style" style="display: none;">
            <button type="button"
                    :class="{'active': getRenderType === 'list' }"
                    @click="updateRenderType('list')"
            ><i class="eicon-post-list"></i></button>
            <button type="button"
                    :class="{'active': getRenderType === 'grid' }"
                    @click="updateRenderType('grid')"
            ><i class="eicon-posts-grid"></i></button>
          </div>
        </div>
      </div>
      <button type="button"
              @click="showFilter"
              class="btn-show-filter"
      ><i class="eicon-filter"></i>&nbsp;Weitere Filter anzeigen</button>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import DrPicker from "../DrPicker";
import {formatDate} from "../helper/date";

export default {
  name: "TnTravelResults",
  components: { DrPicker },
  data: () => ({
    sortOptions: [
      { label: '&uarr; Preis', value: { order_by: 'price', order: 'ASC' } },
      { label: '&darr; Preis', value: { order_by: 'price', order: 'DESC' } },
      { label: '&uarr; Beliebtheit', value: { order_by: 'popularity', order: 'ASC' } },
      { label: '&darr; Beliebtheit', value: { order_by: 'popularity', order: 'DESC' } },
      { label: '&uarr; Abreisedatum', value: { order_by: 'date', order: 'ASC' } },
      { label: '&darr; Abreisedatum', value: { order_by: 'date', order: 'DESC' } },
    ]
  }),
  computed: {
    ...mapGetters(['getBusyState', 'getFilter', 'getSort', 'getRenderType', 'getHtml', 'getTarget']),
    selectedSortOption() {
      let selectedSortOption = this.sortOptions.find(
          option => option.value.order_by === this.getSort.order_by
            && option.value.order === this.getSort.order
      );

      if (!selectedSortOption) {
        selectedSortOption = this.sortOptions[0];
      }

      return selectedSortOption;
    }
  },
  methods: {
    ...mapActions(['updateFilter', 'updateSort', "updateRenderType"]),

    selectDateRangeStart() {
      this.$refs.date_range_start.blur();
      this.$refs.drPicker.show({
        mode: 'range-start',
        range: {
            start: this.$refs.drPicker.parseDate(this.$refs.date_range_start.value),
            end: this.$refs.drPicker.parseDate(this.$refs.date_range_end.value)
        }
      });
    },

    clearDateRangeStart() {
      const rangeStart = formatDate(new Date());
      this.updateFilter({
        date_range: [
          rangeStart,
          this.getFilter.date_range[1],
        ]
      });
      this.$refs.date_range_start.value = rangeStart;
    },

    selectDateRangeEnd() {
      this.$refs.drPicker.show({
        mode: 'range-end',
        range: {
          start: this.$refs.drPicker.parseDate(this.$refs.date_range_start.value),
          end: this.$refs.drPicker.parseDate(this.$refs.date_range_end.value)
        }
      });
    },

    clearDateRangeEnd() {
      this.updateFilter({
        date_range: [
          this.getFilter.date_range[0],
          null
        ]
      })
      this.$refs.date_range_end.value = '';
    },


    updateDateRange(range) {
      this.updateFilter({
        date_range: [
          this.$refs.drPicker.formatDate(range.start),
          this.$refs.drPicker.formatDate(range.end)
        ]
      })
      this.$refs.date_range_start.value = this.$refs.drPicker.formatDate(range.start);
      this.$refs.date_range_end.value = this.$refs.drPicker.formatDate(range.end);
    },

    showFilter() {
      window.document.getElementsByTagName('HTML')[0].classList.add('filter-opened');
    }
  },
  watch: {
    getHtml(html) {
      const container = document.getElementById(this.getTarget);
      if (container) {
        container.innerHTML = html;
      }
    },
    getBusyState(value) {
      const container = document.getElementById(this.getTarget);
      if (container) {
        if (value) {
          container.classList.add("is-busy");
        } else {
          container.classList.remove("is-busy");
        }
      }
    }
  }
}
</script>
<style>
[id^="tn-travel-result-container"] {
  transition: opacity 0.6s;
}
[id^="tn-travel-result-container"].is-busy {
  opacity: .5;
}

</style>
<style scoped lang="scss">

.tn-travel-results {
  padding-bottom: 15px;
}

.tn-travel-teaser-headline+.tn-travel-results {
  padding: 15px;
  background: #ea7819;
  margin-top: -20px;
}

.btn-show-filter {
  display: none;
  height: 42px;
  align-self: flex-end;
}
.view-style {
  border: 1px solid #ccc;
  display: inline-block;
  vertical-align: top;
}
.view-style button {
  padding: 0;
  height: 44px;
  width: 44px;
  font-size: 2em;
  display: inline-block;
  vertical-align: top;
  background: transparent;
}
.view-style button.active  {
  background-color: #910a0a;
  color: #fff;
}

.flex-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-top: -15px;
  margin-left: -15px;
}

.flex-row > * {
  flex: 1 1 auto;
  margin-top: 15px;
  margin-left: 15px;
}

.flex-row > .flex-row {
  margin-left: 0;
  margin-top: 0;
}

.input-wrapper {
  position: relative;
  flex: 1 1 0px;

  input {
    padding-right: 32px;
    width: 100%;
  }

  & > .clear-input {
      background: transparent;
      color: #9b9b9b;
      position: absolute;
      top: 0px;
      right: 0px;
      height: 100%;
      width: 32px;
      padding: 0px;
      margin: 0;

      display: flex;
      align-items: center;
      justify-content: center;

  &>i {
     font-size: 1.8em;
   }
  }
}

@media screen and (max-width: 1023px) {
  .btn-show-filter {
    display: block;
  }
}
@media screen and (max-width: 768px) {
  .btn-show-filter {
    width: 100%;
  }
}
</style>
